module.exports = __webpack_public_path__ + "static/media/009.5a656747.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/people/normals/009.jpg
// module id = 306
// module chunks = 0